// This file is auto-generated by @hey-api/openapi-ts

import {
  type Options,
  registerUserApiAuthRegisterPost,
  loginUserApiAuthLoginPost,
  requestPasswordResetApiAuthPasswordResetPost,
  confirmPasswordResetApiAuthPasswordResetConfirmPost,
  requestEmailVerificationApiAuthVerifyEmailPost,
  getItemsApiItemsGet,
  getItemCategoriesApiItemsCategoriesGet,
  searchItemsApiItemsSearchGet,
  getItemByIdApiItemsItemIdGet,
  getUserInventoryApiInventoryUserUserIdGet,
  getPublicInventoryApiInventoryUserUserIdPublicGet,
  deleteInventoryItemApiInventoryInventoryIdDelete,
  getInventoryItemApiInventoryInventoryIdGet,
  updateInventoryItemApiInventoryInventoryIdPatch,
  addInventoryItemApiInventoryPost,
  healthCheckApiHealthGet,
  getAllListsApiListsGet,
  createListApiListsPost,
  getUserListsByIdApiListsUserUserIdGet,
  deleteListApiListsListIdDelete,
  getListWithSectionsApiListsListIdGet,
  updateListApiListsListIdPut,
  deleteSectionApiListsSectionsSectionIdDelete,
  getSectionWithItemsApiListsSectionsSectionIdGet,
  updateSectionApiListsSectionsSectionIdPut,
  createSectionApiListsSectionsPost,
  bulkUpdateListItemsApiListsItemsBulkPut,
  createListItemApiListsItemsPost,
  deleteListItemApiListsItemsItemIdDelete,
  updateListItemApiListsItemsItemIdPut,
  createHighlightKeyApiListsHighlightsPost,
  deleteHighlightKeyApiListsHighlightsHighlightIdDelete,
  updateHighlightKeyApiListsHighlightsHighlightIdPut,
  getPublicProfilesApiUsersProfilesGet,
  getPublicProfileApiUsersProfilesUserIdGet,
  getMyProfileApiUsersMeGet,
  updateMyProfileApiUsersMePatch,
  uploadAvatarApiUsersMeAvatarPost,
} from '../sdk.gen'
import {
  queryOptions,
  type UseMutationOptions,
  infiniteQueryOptions,
  type InfiniteData,
  type DefaultError,
} from '@tanstack/react-query'
import type {
  RegisterUserApiAuthRegisterPostData,
  RegisterUserApiAuthRegisterPostError,
  RegisterUserApiAuthRegisterPostResponse,
  LoginUserApiAuthLoginPostData,
  LoginUserApiAuthLoginPostError,
  LoginUserApiAuthLoginPostResponse,
  RequestPasswordResetApiAuthPasswordResetPostData,
  RequestPasswordResetApiAuthPasswordResetPostError,
  RequestPasswordResetApiAuthPasswordResetPostResponse,
  ConfirmPasswordResetApiAuthPasswordResetConfirmPostData,
  ConfirmPasswordResetApiAuthPasswordResetConfirmPostError,
  ConfirmPasswordResetApiAuthPasswordResetConfirmPostResponse,
  RequestEmailVerificationApiAuthVerifyEmailPostData,
  RequestEmailVerificationApiAuthVerifyEmailPostError,
  RequestEmailVerificationApiAuthVerifyEmailPostResponse,
  GetItemsApiItemsGetData,
  GetItemsApiItemsGetError,
  GetItemsApiItemsGetResponse,
  GetItemCategoriesApiItemsCategoriesGetData,
  SearchItemsApiItemsSearchGetData,
  SearchItemsApiItemsSearchGetError,
  SearchItemsApiItemsSearchGetResponse,
  GetItemByIdApiItemsItemIdGetData,
  GetUserInventoryApiInventoryUserUserIdGetData,
  GetUserInventoryApiInventoryUserUserIdGetError,
  GetUserInventoryApiInventoryUserUserIdGetResponse,
  GetPublicInventoryApiInventoryUserUserIdPublicGetData,
  GetPublicInventoryApiInventoryUserUserIdPublicGetError,
  GetPublicInventoryApiInventoryUserUserIdPublicGetResponse,
  DeleteInventoryItemApiInventoryInventoryIdDeleteData,
  DeleteInventoryItemApiInventoryInventoryIdDeleteError,
  DeleteInventoryItemApiInventoryInventoryIdDeleteResponse,
  GetInventoryItemApiInventoryInventoryIdGetData,
  UpdateInventoryItemApiInventoryInventoryIdPatchData,
  UpdateInventoryItemApiInventoryInventoryIdPatchError,
  UpdateInventoryItemApiInventoryInventoryIdPatchResponse,
  AddInventoryItemApiInventoryPostData,
  AddInventoryItemApiInventoryPostError,
  AddInventoryItemApiInventoryPostResponse,
  HealthCheckApiHealthGetData,
  GetAllListsApiListsGetData,
  GetAllListsApiListsGetError,
  GetAllListsApiListsGetResponse,
  CreateListApiListsPostData,
  CreateListApiListsPostError,
  CreateListApiListsPostResponse,
  GetUserListsByIdApiListsUserUserIdGetData,
  GetUserListsByIdApiListsUserUserIdGetError,
  GetUserListsByIdApiListsUserUserIdGetResponse,
  DeleteListApiListsListIdDeleteData,
  DeleteListApiListsListIdDeleteError,
  DeleteListApiListsListIdDeleteResponse,
  GetListWithSectionsApiListsListIdGetData,
  UpdateListApiListsListIdPutData,
  UpdateListApiListsListIdPutError,
  UpdateListApiListsListIdPutResponse,
  DeleteSectionApiListsSectionsSectionIdDeleteData,
  DeleteSectionApiListsSectionsSectionIdDeleteError,
  DeleteSectionApiListsSectionsSectionIdDeleteResponse,
  GetSectionWithItemsApiListsSectionsSectionIdGetData,
  UpdateSectionApiListsSectionsSectionIdPutData,
  UpdateSectionApiListsSectionsSectionIdPutError,
  UpdateSectionApiListsSectionsSectionIdPutResponse,
  CreateSectionApiListsSectionsPostData,
  CreateSectionApiListsSectionsPostError,
  CreateSectionApiListsSectionsPostResponse,
  BulkUpdateListItemsApiListsItemsBulkPutData,
  BulkUpdateListItemsApiListsItemsBulkPutError,
  CreateListItemApiListsItemsPostData,
  CreateListItemApiListsItemsPostError,
  CreateListItemApiListsItemsPostResponse,
  DeleteListItemApiListsItemsItemIdDeleteData,
  DeleteListItemApiListsItemsItemIdDeleteError,
  DeleteListItemApiListsItemsItemIdDeleteResponse,
  UpdateListItemApiListsItemsItemIdPutData,
  UpdateListItemApiListsItemsItemIdPutError,
  UpdateListItemApiListsItemsItemIdPutResponse,
  CreateHighlightKeyApiListsHighlightsPostData,
  CreateHighlightKeyApiListsHighlightsPostError,
  CreateHighlightKeyApiListsHighlightsPostResponse,
  DeleteHighlightKeyApiListsHighlightsHighlightIdDeleteData,
  DeleteHighlightKeyApiListsHighlightsHighlightIdDeleteError,
  DeleteHighlightKeyApiListsHighlightsHighlightIdDeleteResponse,
  UpdateHighlightKeyApiListsHighlightsHighlightIdPutData,
  UpdateHighlightKeyApiListsHighlightsHighlightIdPutError,
  UpdateHighlightKeyApiListsHighlightsHighlightIdPutResponse,
  GetPublicProfilesApiUsersProfilesGetData,
  GetPublicProfileApiUsersProfilesUserIdGetData,
  GetMyProfileApiUsersMeGetData,
  UpdateMyProfileApiUsersMePatchData,
  UpdateMyProfileApiUsersMePatchError,
  UpdateMyProfileApiUsersMePatchResponse,
  UploadAvatarApiUsersMeAvatarPostData,
  UploadAvatarApiUsersMeAvatarPostResponse,
} from '../types.gen'
import { client as _heyApiClient } from '../client.gen'

export type QueryKey<TOptions extends Options> = [
  Pick<TOptions, 'baseUrl' | 'body' | 'headers' | 'path' | 'query'> & {
    _id: string
    _infinite?: boolean
  },
]

const createQueryKey = <TOptions extends Options>(
  id: string,
  options?: TOptions,
  infinite?: boolean,
): [QueryKey<TOptions>[0]] => {
  const params: QueryKey<TOptions>[0] = {
    _id: id,
    baseUrl: (options?.client ?? _heyApiClient).getConfig().baseUrl,
  } as QueryKey<TOptions>[0]
  if (infinite) {
    params._infinite = infinite
  }
  if (options?.body) {
    params.body = options.body
  }
  if (options?.headers) {
    params.headers = options.headers
  }
  if (options?.path) {
    params.path = options.path
  }
  if (options?.query) {
    params.query = options.query
  }
  return [params]
}

export const registerUserApiAuthRegisterPostQueryKey = (options: Options<RegisterUserApiAuthRegisterPostData>) =>
  createQueryKey('registerUserApiAuthRegisterPost', options)

export const registerUserApiAuthRegisterPostOptions = (options: Options<RegisterUserApiAuthRegisterPostData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await registerUserApiAuthRegisterPost({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: registerUserApiAuthRegisterPostQueryKey(options),
  })
}

export const registerUserApiAuthRegisterPostMutation = (
  options?: Partial<Options<RegisterUserApiAuthRegisterPostData>>,
): UseMutationOptions<
  RegisterUserApiAuthRegisterPostResponse,
  RegisterUserApiAuthRegisterPostError,
  Options<RegisterUserApiAuthRegisterPostData>
> => {
  const mutationOptions: UseMutationOptions<
    RegisterUserApiAuthRegisterPostResponse,
    RegisterUserApiAuthRegisterPostError,
    Options<RegisterUserApiAuthRegisterPostData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await registerUserApiAuthRegisterPost({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const loginUserApiAuthLoginPostQueryKey = (options: Options<LoginUserApiAuthLoginPostData>) =>
  createQueryKey('loginUserApiAuthLoginPost', options)

export const loginUserApiAuthLoginPostOptions = (options: Options<LoginUserApiAuthLoginPostData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await loginUserApiAuthLoginPost({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: loginUserApiAuthLoginPostQueryKey(options),
  })
}

export const loginUserApiAuthLoginPostMutation = (
  options?: Partial<Options<LoginUserApiAuthLoginPostData>>,
): UseMutationOptions<
  LoginUserApiAuthLoginPostResponse,
  LoginUserApiAuthLoginPostError,
  Options<LoginUserApiAuthLoginPostData>
> => {
  const mutationOptions: UseMutationOptions<
    LoginUserApiAuthLoginPostResponse,
    LoginUserApiAuthLoginPostError,
    Options<LoginUserApiAuthLoginPostData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await loginUserApiAuthLoginPost({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const requestPasswordResetApiAuthPasswordResetPostQueryKey = (
  options: Options<RequestPasswordResetApiAuthPasswordResetPostData>,
) => createQueryKey('requestPasswordResetApiAuthPasswordResetPost', options)

export const requestPasswordResetApiAuthPasswordResetPostOptions = (
  options: Options<RequestPasswordResetApiAuthPasswordResetPostData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await requestPasswordResetApiAuthPasswordResetPost({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: requestPasswordResetApiAuthPasswordResetPostQueryKey(options),
  })
}

export const requestPasswordResetApiAuthPasswordResetPostMutation = (
  options?: Partial<Options<RequestPasswordResetApiAuthPasswordResetPostData>>,
): UseMutationOptions<
  RequestPasswordResetApiAuthPasswordResetPostResponse,
  RequestPasswordResetApiAuthPasswordResetPostError,
  Options<RequestPasswordResetApiAuthPasswordResetPostData>
> => {
  const mutationOptions: UseMutationOptions<
    RequestPasswordResetApiAuthPasswordResetPostResponse,
    RequestPasswordResetApiAuthPasswordResetPostError,
    Options<RequestPasswordResetApiAuthPasswordResetPostData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await requestPasswordResetApiAuthPasswordResetPost({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const confirmPasswordResetApiAuthPasswordResetConfirmPostQueryKey = (
  options: Options<ConfirmPasswordResetApiAuthPasswordResetConfirmPostData>,
) => createQueryKey('confirmPasswordResetApiAuthPasswordResetConfirmPost', options)

export const confirmPasswordResetApiAuthPasswordResetConfirmPostOptions = (
  options: Options<ConfirmPasswordResetApiAuthPasswordResetConfirmPostData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await confirmPasswordResetApiAuthPasswordResetConfirmPost({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: confirmPasswordResetApiAuthPasswordResetConfirmPostQueryKey(options),
  })
}

export const confirmPasswordResetApiAuthPasswordResetConfirmPostMutation = (
  options?: Partial<Options<ConfirmPasswordResetApiAuthPasswordResetConfirmPostData>>,
): UseMutationOptions<
  ConfirmPasswordResetApiAuthPasswordResetConfirmPostResponse,
  ConfirmPasswordResetApiAuthPasswordResetConfirmPostError,
  Options<ConfirmPasswordResetApiAuthPasswordResetConfirmPostData>
> => {
  const mutationOptions: UseMutationOptions<
    ConfirmPasswordResetApiAuthPasswordResetConfirmPostResponse,
    ConfirmPasswordResetApiAuthPasswordResetConfirmPostError,
    Options<ConfirmPasswordResetApiAuthPasswordResetConfirmPostData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await confirmPasswordResetApiAuthPasswordResetConfirmPost({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const requestEmailVerificationApiAuthVerifyEmailPostQueryKey = (
  options: Options<RequestEmailVerificationApiAuthVerifyEmailPostData>,
) => createQueryKey('requestEmailVerificationApiAuthVerifyEmailPost', options)

export const requestEmailVerificationApiAuthVerifyEmailPostOptions = (
  options: Options<RequestEmailVerificationApiAuthVerifyEmailPostData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await requestEmailVerificationApiAuthVerifyEmailPost({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: requestEmailVerificationApiAuthVerifyEmailPostQueryKey(options),
  })
}

export const requestEmailVerificationApiAuthVerifyEmailPostMutation = (
  options?: Partial<Options<RequestEmailVerificationApiAuthVerifyEmailPostData>>,
): UseMutationOptions<
  RequestEmailVerificationApiAuthVerifyEmailPostResponse,
  RequestEmailVerificationApiAuthVerifyEmailPostError,
  Options<RequestEmailVerificationApiAuthVerifyEmailPostData>
> => {
  const mutationOptions: UseMutationOptions<
    RequestEmailVerificationApiAuthVerifyEmailPostResponse,
    RequestEmailVerificationApiAuthVerifyEmailPostError,
    Options<RequestEmailVerificationApiAuthVerifyEmailPostData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await requestEmailVerificationApiAuthVerifyEmailPost({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const getItemsApiItemsGetQueryKey = (options?: Options<GetItemsApiItemsGetData>) =>
  createQueryKey('getItemsApiItemsGet', options)

export const getItemsApiItemsGetOptions = (options?: Options<GetItemsApiItemsGetData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getItemsApiItemsGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getItemsApiItemsGetQueryKey(options),
  })
}

const createInfiniteParams = <K extends Pick<QueryKey<Options>[0], 'body' | 'headers' | 'path' | 'query'>>(
  queryKey: QueryKey<Options>,
  page: K,
) => {
  const params = queryKey[0]
  if (page.body) {
    params.body = {
      ...(queryKey[0].body as any),
      ...(page.body as any),
    }
  }
  if (page.headers) {
    params.headers = {
      ...queryKey[0].headers,
      ...page.headers,
    }
  }
  if (page.path) {
    params.path = {
      ...(queryKey[0].path as any),
      ...(page.path as any),
    }
  }
  if (page.query) {
    params.query = {
      ...(queryKey[0].query as any),
      ...(page.query as any),
    }
  }
  return params as unknown as typeof page
}

export const getItemsApiItemsGetInfiniteQueryKey = (
  options?: Options<GetItemsApiItemsGetData>,
): QueryKey<Options<GetItemsApiItemsGetData>> => createQueryKey('getItemsApiItemsGet', options, true)

export const getItemsApiItemsGetInfiniteOptions = (options?: Options<GetItemsApiItemsGetData>) => {
  return infiniteQueryOptions<
    GetItemsApiItemsGetResponse,
    GetItemsApiItemsGetError,
    InfiniteData<GetItemsApiItemsGetResponse>,
    QueryKey<Options<GetItemsApiItemsGetData>>,
    number | Pick<QueryKey<Options<GetItemsApiItemsGetData>>[0], 'body' | 'headers' | 'path' | 'query'>
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<GetItemsApiItemsGetData>>[0], 'body' | 'headers' | 'path' | 'query'> =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam,
                },
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await getItemsApiItemsGet({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        })
        return data
      },
      queryKey: getItemsApiItemsGetInfiniteQueryKey(options),
    },
  )
}

export const getItemCategoriesApiItemsCategoriesGetQueryKey = (
  options?: Options<GetItemCategoriesApiItemsCategoriesGetData>,
) => createQueryKey('getItemCategoriesApiItemsCategoriesGet', options)

export const getItemCategoriesApiItemsCategoriesGetOptions = (
  options?: Options<GetItemCategoriesApiItemsCategoriesGetData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getItemCategoriesApiItemsCategoriesGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getItemCategoriesApiItemsCategoriesGetQueryKey(options),
  })
}

export const searchItemsApiItemsSearchGetQueryKey = (options: Options<SearchItemsApiItemsSearchGetData>) =>
  createQueryKey('searchItemsApiItemsSearchGet', options)

export const searchItemsApiItemsSearchGetOptions = (options: Options<SearchItemsApiItemsSearchGetData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await searchItemsApiItemsSearchGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: searchItemsApiItemsSearchGetQueryKey(options),
  })
}

export const searchItemsApiItemsSearchGetInfiniteQueryKey = (
  options: Options<SearchItemsApiItemsSearchGetData>,
): QueryKey<Options<SearchItemsApiItemsSearchGetData>> => createQueryKey('searchItemsApiItemsSearchGet', options, true)

export const searchItemsApiItemsSearchGetInfiniteOptions = (options: Options<SearchItemsApiItemsSearchGetData>) => {
  return infiniteQueryOptions<
    SearchItemsApiItemsSearchGetResponse,
    SearchItemsApiItemsSearchGetError,
    InfiniteData<SearchItemsApiItemsSearchGetResponse>,
    QueryKey<Options<SearchItemsApiItemsSearchGetData>>,
    number | Pick<QueryKey<Options<SearchItemsApiItemsSearchGetData>>[0], 'body' | 'headers' | 'path' | 'query'>
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<SearchItemsApiItemsSearchGetData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam,
                },
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await searchItemsApiItemsSearchGet({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        })
        return data
      },
      queryKey: searchItemsApiItemsSearchGetInfiniteQueryKey(options),
    },
  )
}

export const getItemByIdApiItemsItemIdGetQueryKey = (options: Options<GetItemByIdApiItemsItemIdGetData>) =>
  createQueryKey('getItemByIdApiItemsItemIdGet', options)

export const getItemByIdApiItemsItemIdGetOptions = (options: Options<GetItemByIdApiItemsItemIdGetData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getItemByIdApiItemsItemIdGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getItemByIdApiItemsItemIdGetQueryKey(options),
  })
}

export const getUserInventoryApiInventoryUserUserIdGetQueryKey = (
  options: Options<GetUserInventoryApiInventoryUserUserIdGetData>,
) => createQueryKey('getUserInventoryApiInventoryUserUserIdGet', options)

export const getUserInventoryApiInventoryUserUserIdGetOptions = (
  options: Options<GetUserInventoryApiInventoryUserUserIdGetData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getUserInventoryApiInventoryUserUserIdGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getUserInventoryApiInventoryUserUserIdGetQueryKey(options),
  })
}

export const getUserInventoryApiInventoryUserUserIdGetInfiniteQueryKey = (
  options: Options<GetUserInventoryApiInventoryUserUserIdGetData>,
): QueryKey<Options<GetUserInventoryApiInventoryUserUserIdGetData>> =>
  createQueryKey('getUserInventoryApiInventoryUserUserIdGet', options, true)

export const getUserInventoryApiInventoryUserUserIdGetInfiniteOptions = (
  options: Options<GetUserInventoryApiInventoryUserUserIdGetData>,
) => {
  return infiniteQueryOptions<
    GetUserInventoryApiInventoryUserUserIdGetResponse,
    GetUserInventoryApiInventoryUserUserIdGetError,
    InfiniteData<GetUserInventoryApiInventoryUserUserIdGetResponse>,
    QueryKey<Options<GetUserInventoryApiInventoryUserUserIdGetData>>,
    | number
    | Pick<QueryKey<Options<GetUserInventoryApiInventoryUserUserIdGetData>>[0], 'body' | 'headers' | 'path' | 'query'>
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetUserInventoryApiInventoryUserUserIdGetData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam,
                },
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await getUserInventoryApiInventoryUserUserIdGet({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        })
        return data
      },
      queryKey: getUserInventoryApiInventoryUserUserIdGetInfiniteQueryKey(options),
    },
  )
}

export const getPublicInventoryApiInventoryUserUserIdPublicGetQueryKey = (
  options: Options<GetPublicInventoryApiInventoryUserUserIdPublicGetData>,
) => createQueryKey('getPublicInventoryApiInventoryUserUserIdPublicGet', options)

export const getPublicInventoryApiInventoryUserUserIdPublicGetOptions = (
  options: Options<GetPublicInventoryApiInventoryUserUserIdPublicGetData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getPublicInventoryApiInventoryUserUserIdPublicGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getPublicInventoryApiInventoryUserUserIdPublicGetQueryKey(options),
  })
}

export const getPublicInventoryApiInventoryUserUserIdPublicGetInfiniteQueryKey = (
  options: Options<GetPublicInventoryApiInventoryUserUserIdPublicGetData>,
): QueryKey<Options<GetPublicInventoryApiInventoryUserUserIdPublicGetData>> =>
  createQueryKey('getPublicInventoryApiInventoryUserUserIdPublicGet', options, true)

export const getPublicInventoryApiInventoryUserUserIdPublicGetInfiniteOptions = (
  options: Options<GetPublicInventoryApiInventoryUserUserIdPublicGetData>,
) => {
  return infiniteQueryOptions<
    GetPublicInventoryApiInventoryUserUserIdPublicGetResponse,
    GetPublicInventoryApiInventoryUserUserIdPublicGetError,
    InfiniteData<GetPublicInventoryApiInventoryUserUserIdPublicGetResponse>,
    QueryKey<Options<GetPublicInventoryApiInventoryUserUserIdPublicGetData>>,
    | number
    | Pick<
        QueryKey<Options<GetPublicInventoryApiInventoryUserUserIdPublicGetData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetPublicInventoryApiInventoryUserUserIdPublicGetData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam,
                },
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await getPublicInventoryApiInventoryUserUserIdPublicGet({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        })
        return data
      },
      queryKey: getPublicInventoryApiInventoryUserUserIdPublicGetInfiniteQueryKey(options),
    },
  )
}

export const deleteInventoryItemApiInventoryInventoryIdDeleteMutation = (
  options?: Partial<Options<DeleteInventoryItemApiInventoryInventoryIdDeleteData>>,
): UseMutationOptions<
  DeleteInventoryItemApiInventoryInventoryIdDeleteResponse,
  DeleteInventoryItemApiInventoryInventoryIdDeleteError,
  Options<DeleteInventoryItemApiInventoryInventoryIdDeleteData>
> => {
  const mutationOptions: UseMutationOptions<
    DeleteInventoryItemApiInventoryInventoryIdDeleteResponse,
    DeleteInventoryItemApiInventoryInventoryIdDeleteError,
    Options<DeleteInventoryItemApiInventoryInventoryIdDeleteData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await deleteInventoryItemApiInventoryInventoryIdDelete({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const getInventoryItemApiInventoryInventoryIdGetQueryKey = (
  options: Options<GetInventoryItemApiInventoryInventoryIdGetData>,
) => createQueryKey('getInventoryItemApiInventoryInventoryIdGet', options)

export const getInventoryItemApiInventoryInventoryIdGetOptions = (
  options: Options<GetInventoryItemApiInventoryInventoryIdGetData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getInventoryItemApiInventoryInventoryIdGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getInventoryItemApiInventoryInventoryIdGetQueryKey(options),
  })
}

export const updateInventoryItemApiInventoryInventoryIdPatchMutation = (
  options?: Partial<Options<UpdateInventoryItemApiInventoryInventoryIdPatchData>>,
): UseMutationOptions<
  UpdateInventoryItemApiInventoryInventoryIdPatchResponse,
  UpdateInventoryItemApiInventoryInventoryIdPatchError,
  Options<UpdateInventoryItemApiInventoryInventoryIdPatchData>
> => {
  const mutationOptions: UseMutationOptions<
    UpdateInventoryItemApiInventoryInventoryIdPatchResponse,
    UpdateInventoryItemApiInventoryInventoryIdPatchError,
    Options<UpdateInventoryItemApiInventoryInventoryIdPatchData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await updateInventoryItemApiInventoryInventoryIdPatch({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const addInventoryItemApiInventoryPostQueryKey = (options: Options<AddInventoryItemApiInventoryPostData>) =>
  createQueryKey('addInventoryItemApiInventoryPost', options)

export const addInventoryItemApiInventoryPostOptions = (options: Options<AddInventoryItemApiInventoryPostData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await addInventoryItemApiInventoryPost({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: addInventoryItemApiInventoryPostQueryKey(options),
  })
}

export const addInventoryItemApiInventoryPostMutation = (
  options?: Partial<Options<AddInventoryItemApiInventoryPostData>>,
): UseMutationOptions<
  AddInventoryItemApiInventoryPostResponse,
  AddInventoryItemApiInventoryPostError,
  Options<AddInventoryItemApiInventoryPostData>
> => {
  const mutationOptions: UseMutationOptions<
    AddInventoryItemApiInventoryPostResponse,
    AddInventoryItemApiInventoryPostError,
    Options<AddInventoryItemApiInventoryPostData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await addInventoryItemApiInventoryPost({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const healthCheckApiHealthGetQueryKey = (options?: Options<HealthCheckApiHealthGetData>) =>
  createQueryKey('healthCheckApiHealthGet', options)

export const healthCheckApiHealthGetOptions = (options?: Options<HealthCheckApiHealthGetData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await healthCheckApiHealthGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: healthCheckApiHealthGetQueryKey(options),
  })
}

export const getAllListsApiListsGetQueryKey = (options?: Options<GetAllListsApiListsGetData>) =>
  createQueryKey('getAllListsApiListsGet', options)

export const getAllListsApiListsGetOptions = (options?: Options<GetAllListsApiListsGetData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getAllListsApiListsGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getAllListsApiListsGetQueryKey(options),
  })
}

export const getAllListsApiListsGetInfiniteQueryKey = (
  options?: Options<GetAllListsApiListsGetData>,
): QueryKey<Options<GetAllListsApiListsGetData>> => createQueryKey('getAllListsApiListsGet', options, true)

export const getAllListsApiListsGetInfiniteOptions = (options?: Options<GetAllListsApiListsGetData>) => {
  return infiniteQueryOptions<
    GetAllListsApiListsGetResponse,
    GetAllListsApiListsGetError,
    InfiniteData<GetAllListsApiListsGetResponse>,
    QueryKey<Options<GetAllListsApiListsGetData>>,
    number | Pick<QueryKey<Options<GetAllListsApiListsGetData>>[0], 'body' | 'headers' | 'path' | 'query'>
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<GetAllListsApiListsGetData>>[0], 'body' | 'headers' | 'path' | 'query'> =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam,
                },
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await getAllListsApiListsGet({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        })
        return data
      },
      queryKey: getAllListsApiListsGetInfiniteQueryKey(options),
    },
  )
}

export const createListApiListsPostQueryKey = (options: Options<CreateListApiListsPostData>) =>
  createQueryKey('createListApiListsPost', options)

export const createListApiListsPostOptions = (options: Options<CreateListApiListsPostData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await createListApiListsPost({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: createListApiListsPostQueryKey(options),
  })
}

export const createListApiListsPostMutation = (
  options?: Partial<Options<CreateListApiListsPostData>>,
): UseMutationOptions<
  CreateListApiListsPostResponse,
  CreateListApiListsPostError,
  Options<CreateListApiListsPostData>
> => {
  const mutationOptions: UseMutationOptions<
    CreateListApiListsPostResponse,
    CreateListApiListsPostError,
    Options<CreateListApiListsPostData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await createListApiListsPost({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const getUserListsByIdApiListsUserUserIdGetQueryKey = (
  options: Options<GetUserListsByIdApiListsUserUserIdGetData>,
) => createQueryKey('getUserListsByIdApiListsUserUserIdGet', options)

export const getUserListsByIdApiListsUserUserIdGetOptions = (
  options: Options<GetUserListsByIdApiListsUserUserIdGetData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getUserListsByIdApiListsUserUserIdGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getUserListsByIdApiListsUserUserIdGetQueryKey(options),
  })
}

export const getUserListsByIdApiListsUserUserIdGetInfiniteQueryKey = (
  options: Options<GetUserListsByIdApiListsUserUserIdGetData>,
): QueryKey<Options<GetUserListsByIdApiListsUserUserIdGetData>> =>
  createQueryKey('getUserListsByIdApiListsUserUserIdGet', options, true)

export const getUserListsByIdApiListsUserUserIdGetInfiniteOptions = (
  options: Options<GetUserListsByIdApiListsUserUserIdGetData>,
) => {
  return infiniteQueryOptions<
    GetUserListsByIdApiListsUserUserIdGetResponse,
    GetUserListsByIdApiListsUserUserIdGetError,
    InfiniteData<GetUserListsByIdApiListsUserUserIdGetResponse>,
    QueryKey<Options<GetUserListsByIdApiListsUserUserIdGetData>>,
    | number
    | Pick<QueryKey<Options<GetUserListsByIdApiListsUserUserIdGetData>>[0], 'body' | 'headers' | 'path' | 'query'>
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetUserListsByIdApiListsUserUserIdGetData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam,
                },
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await getUserListsByIdApiListsUserUserIdGet({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        })
        return data
      },
      queryKey: getUserListsByIdApiListsUserUserIdGetInfiniteQueryKey(options),
    },
  )
}

export const deleteListApiListsListIdDeleteMutation = (
  options?: Partial<Options<DeleteListApiListsListIdDeleteData>>,
): UseMutationOptions<
  DeleteListApiListsListIdDeleteResponse,
  DeleteListApiListsListIdDeleteError,
  Options<DeleteListApiListsListIdDeleteData>
> => {
  const mutationOptions: UseMutationOptions<
    DeleteListApiListsListIdDeleteResponse,
    DeleteListApiListsListIdDeleteError,
    Options<DeleteListApiListsListIdDeleteData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await deleteListApiListsListIdDelete({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const getListWithSectionsApiListsListIdGetQueryKey = (
  options: Options<GetListWithSectionsApiListsListIdGetData>,
) => createQueryKey('getListWithSectionsApiListsListIdGet', options)

export const getListWithSectionsApiListsListIdGetOptions = (
  options: Options<GetListWithSectionsApiListsListIdGetData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getListWithSectionsApiListsListIdGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getListWithSectionsApiListsListIdGetQueryKey(options),
  })
}

export const updateListApiListsListIdPutMutation = (
  options?: Partial<Options<UpdateListApiListsListIdPutData>>,
): UseMutationOptions<
  UpdateListApiListsListIdPutResponse,
  UpdateListApiListsListIdPutError,
  Options<UpdateListApiListsListIdPutData>
> => {
  const mutationOptions: UseMutationOptions<
    UpdateListApiListsListIdPutResponse,
    UpdateListApiListsListIdPutError,
    Options<UpdateListApiListsListIdPutData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await updateListApiListsListIdPut({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const deleteSectionApiListsSectionsSectionIdDeleteMutation = (
  options?: Partial<Options<DeleteSectionApiListsSectionsSectionIdDeleteData>>,
): UseMutationOptions<
  DeleteSectionApiListsSectionsSectionIdDeleteResponse,
  DeleteSectionApiListsSectionsSectionIdDeleteError,
  Options<DeleteSectionApiListsSectionsSectionIdDeleteData>
> => {
  const mutationOptions: UseMutationOptions<
    DeleteSectionApiListsSectionsSectionIdDeleteResponse,
    DeleteSectionApiListsSectionsSectionIdDeleteError,
    Options<DeleteSectionApiListsSectionsSectionIdDeleteData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await deleteSectionApiListsSectionsSectionIdDelete({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const getSectionWithItemsApiListsSectionsSectionIdGetQueryKey = (
  options: Options<GetSectionWithItemsApiListsSectionsSectionIdGetData>,
) => createQueryKey('getSectionWithItemsApiListsSectionsSectionIdGet', options)

export const getSectionWithItemsApiListsSectionsSectionIdGetOptions = (
  options: Options<GetSectionWithItemsApiListsSectionsSectionIdGetData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getSectionWithItemsApiListsSectionsSectionIdGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getSectionWithItemsApiListsSectionsSectionIdGetQueryKey(options),
  })
}

export const updateSectionApiListsSectionsSectionIdPutMutation = (
  options?: Partial<Options<UpdateSectionApiListsSectionsSectionIdPutData>>,
): UseMutationOptions<
  UpdateSectionApiListsSectionsSectionIdPutResponse,
  UpdateSectionApiListsSectionsSectionIdPutError,
  Options<UpdateSectionApiListsSectionsSectionIdPutData>
> => {
  const mutationOptions: UseMutationOptions<
    UpdateSectionApiListsSectionsSectionIdPutResponse,
    UpdateSectionApiListsSectionsSectionIdPutError,
    Options<UpdateSectionApiListsSectionsSectionIdPutData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await updateSectionApiListsSectionsSectionIdPut({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const createSectionApiListsSectionsPostQueryKey = (options: Options<CreateSectionApiListsSectionsPostData>) =>
  createQueryKey('createSectionApiListsSectionsPost', options)

export const createSectionApiListsSectionsPostOptions = (options: Options<CreateSectionApiListsSectionsPostData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await createSectionApiListsSectionsPost({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: createSectionApiListsSectionsPostQueryKey(options),
  })
}

export const createSectionApiListsSectionsPostMutation = (
  options?: Partial<Options<CreateSectionApiListsSectionsPostData>>,
): UseMutationOptions<
  CreateSectionApiListsSectionsPostResponse,
  CreateSectionApiListsSectionsPostError,
  Options<CreateSectionApiListsSectionsPostData>
> => {
  const mutationOptions: UseMutationOptions<
    CreateSectionApiListsSectionsPostResponse,
    CreateSectionApiListsSectionsPostError,
    Options<CreateSectionApiListsSectionsPostData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await createSectionApiListsSectionsPost({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const bulkUpdateListItemsApiListsItemsBulkPutMutation = (
  options?: Partial<Options<BulkUpdateListItemsApiListsItemsBulkPutData>>,
): UseMutationOptions<
  unknown,
  BulkUpdateListItemsApiListsItemsBulkPutError,
  Options<BulkUpdateListItemsApiListsItemsBulkPutData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    BulkUpdateListItemsApiListsItemsBulkPutError,
    Options<BulkUpdateListItemsApiListsItemsBulkPutData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await bulkUpdateListItemsApiListsItemsBulkPut({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const createListItemApiListsItemsPostQueryKey = (options: Options<CreateListItemApiListsItemsPostData>) =>
  createQueryKey('createListItemApiListsItemsPost', options)

export const createListItemApiListsItemsPostOptions = (options: Options<CreateListItemApiListsItemsPostData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await createListItemApiListsItemsPost({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: createListItemApiListsItemsPostQueryKey(options),
  })
}

export const createListItemApiListsItemsPostMutation = (
  options?: Partial<Options<CreateListItemApiListsItemsPostData>>,
): UseMutationOptions<
  CreateListItemApiListsItemsPostResponse,
  CreateListItemApiListsItemsPostError,
  Options<CreateListItemApiListsItemsPostData>
> => {
  const mutationOptions: UseMutationOptions<
    CreateListItemApiListsItemsPostResponse,
    CreateListItemApiListsItemsPostError,
    Options<CreateListItemApiListsItemsPostData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await createListItemApiListsItemsPost({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const deleteListItemApiListsItemsItemIdDeleteMutation = (
  options?: Partial<Options<DeleteListItemApiListsItemsItemIdDeleteData>>,
): UseMutationOptions<
  DeleteListItemApiListsItemsItemIdDeleteResponse,
  DeleteListItemApiListsItemsItemIdDeleteError,
  Options<DeleteListItemApiListsItemsItemIdDeleteData>
> => {
  const mutationOptions: UseMutationOptions<
    DeleteListItemApiListsItemsItemIdDeleteResponse,
    DeleteListItemApiListsItemsItemIdDeleteError,
    Options<DeleteListItemApiListsItemsItemIdDeleteData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await deleteListItemApiListsItemsItemIdDelete({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const updateListItemApiListsItemsItemIdPutMutation = (
  options?: Partial<Options<UpdateListItemApiListsItemsItemIdPutData>>,
): UseMutationOptions<
  UpdateListItemApiListsItemsItemIdPutResponse,
  UpdateListItemApiListsItemsItemIdPutError,
  Options<UpdateListItemApiListsItemsItemIdPutData>
> => {
  const mutationOptions: UseMutationOptions<
    UpdateListItemApiListsItemsItemIdPutResponse,
    UpdateListItemApiListsItemsItemIdPutError,
    Options<UpdateListItemApiListsItemsItemIdPutData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await updateListItemApiListsItemsItemIdPut({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const createHighlightKeyApiListsHighlightsPostQueryKey = (
  options: Options<CreateHighlightKeyApiListsHighlightsPostData>,
) => createQueryKey('createHighlightKeyApiListsHighlightsPost', options)

export const createHighlightKeyApiListsHighlightsPostOptions = (
  options: Options<CreateHighlightKeyApiListsHighlightsPostData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await createHighlightKeyApiListsHighlightsPost({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: createHighlightKeyApiListsHighlightsPostQueryKey(options),
  })
}

export const createHighlightKeyApiListsHighlightsPostMutation = (
  options?: Partial<Options<CreateHighlightKeyApiListsHighlightsPostData>>,
): UseMutationOptions<
  CreateHighlightKeyApiListsHighlightsPostResponse,
  CreateHighlightKeyApiListsHighlightsPostError,
  Options<CreateHighlightKeyApiListsHighlightsPostData>
> => {
  const mutationOptions: UseMutationOptions<
    CreateHighlightKeyApiListsHighlightsPostResponse,
    CreateHighlightKeyApiListsHighlightsPostError,
    Options<CreateHighlightKeyApiListsHighlightsPostData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await createHighlightKeyApiListsHighlightsPost({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const deleteHighlightKeyApiListsHighlightsHighlightIdDeleteMutation = (
  options?: Partial<Options<DeleteHighlightKeyApiListsHighlightsHighlightIdDeleteData>>,
): UseMutationOptions<
  DeleteHighlightKeyApiListsHighlightsHighlightIdDeleteResponse,
  DeleteHighlightKeyApiListsHighlightsHighlightIdDeleteError,
  Options<DeleteHighlightKeyApiListsHighlightsHighlightIdDeleteData>
> => {
  const mutationOptions: UseMutationOptions<
    DeleteHighlightKeyApiListsHighlightsHighlightIdDeleteResponse,
    DeleteHighlightKeyApiListsHighlightsHighlightIdDeleteError,
    Options<DeleteHighlightKeyApiListsHighlightsHighlightIdDeleteData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await deleteHighlightKeyApiListsHighlightsHighlightIdDelete({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const updateHighlightKeyApiListsHighlightsHighlightIdPutMutation = (
  options?: Partial<Options<UpdateHighlightKeyApiListsHighlightsHighlightIdPutData>>,
): UseMutationOptions<
  UpdateHighlightKeyApiListsHighlightsHighlightIdPutResponse,
  UpdateHighlightKeyApiListsHighlightsHighlightIdPutError,
  Options<UpdateHighlightKeyApiListsHighlightsHighlightIdPutData>
> => {
  const mutationOptions: UseMutationOptions<
    UpdateHighlightKeyApiListsHighlightsHighlightIdPutResponse,
    UpdateHighlightKeyApiListsHighlightsHighlightIdPutError,
    Options<UpdateHighlightKeyApiListsHighlightsHighlightIdPutData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await updateHighlightKeyApiListsHighlightsHighlightIdPut({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const getPublicProfilesApiUsersProfilesGetQueryKey = (
  options?: Options<GetPublicProfilesApiUsersProfilesGetData>,
) => createQueryKey('getPublicProfilesApiUsersProfilesGet', options)

export const getPublicProfilesApiUsersProfilesGetOptions = (
  options?: Options<GetPublicProfilesApiUsersProfilesGetData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getPublicProfilesApiUsersProfilesGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getPublicProfilesApiUsersProfilesGetQueryKey(options),
  })
}

export const getPublicProfileApiUsersProfilesUserIdGetQueryKey = (
  options: Options<GetPublicProfileApiUsersProfilesUserIdGetData>,
) => createQueryKey('getPublicProfileApiUsersProfilesUserIdGet', options)

export const getPublicProfileApiUsersProfilesUserIdGetOptions = (
  options: Options<GetPublicProfileApiUsersProfilesUserIdGetData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getPublicProfileApiUsersProfilesUserIdGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getPublicProfileApiUsersProfilesUserIdGetQueryKey(options),
  })
}

export const getMyProfileApiUsersMeGetQueryKey = (options?: Options<GetMyProfileApiUsersMeGetData>) =>
  createQueryKey('getMyProfileApiUsersMeGet', options)

export const getMyProfileApiUsersMeGetOptions = (options?: Options<GetMyProfileApiUsersMeGetData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getMyProfileApiUsersMeGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getMyProfileApiUsersMeGetQueryKey(options),
  })
}

export const updateMyProfileApiUsersMePatchMutation = (
  options?: Partial<Options<UpdateMyProfileApiUsersMePatchData>>,
): UseMutationOptions<
  UpdateMyProfileApiUsersMePatchResponse,
  UpdateMyProfileApiUsersMePatchError,
  Options<UpdateMyProfileApiUsersMePatchData>
> => {
  const mutationOptions: UseMutationOptions<
    UpdateMyProfileApiUsersMePatchResponse,
    UpdateMyProfileApiUsersMePatchError,
    Options<UpdateMyProfileApiUsersMePatchData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await updateMyProfileApiUsersMePatch({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const uploadAvatarApiUsersMeAvatarPostQueryKey = (options: Options<UploadAvatarApiUsersMeAvatarPostData>) =>
  createQueryKey('uploadAvatarApiUsersMeAvatarPost', options)

export const uploadAvatarApiUsersMeAvatarPostOptions = (options: Options<UploadAvatarApiUsersMeAvatarPostData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await uploadAvatarApiUsersMeAvatarPost({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: uploadAvatarApiUsersMeAvatarPostQueryKey(options),
  })
}

export const uploadAvatarApiUsersMeAvatarPostMutation = (
  options?: Partial<Options<UploadAvatarApiUsersMeAvatarPostData>>,
): UseMutationOptions<
  UploadAvatarApiUsersMeAvatarPostResponse,
  DefaultError,
  Options<UploadAvatarApiUsersMeAvatarPostData>
> => {
  const mutationOptions: UseMutationOptions<
    UploadAvatarApiUsersMeAvatarPostResponse,
    DefaultError,
    Options<UploadAvatarApiUsersMeAvatarPostData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await uploadAvatarApiUsersMeAvatarPost({
        ...options,
        ...localOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}
